export { MdbChipsInputDirective, MdbChipAddEvent } from './chips-input.directive';
export { MdbChipComponent, MdbChipEditedEvent } from './chip.component';
export { MdbChipsComponent } from './chips.component';
export { MdbChipDeleteDirective } from './chip-delete.directive';
export { MdbChipsModule } from './chips.module';
